/**
 * State used in rendering InteractionTag
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
